import { saveAs } from 'file-saver';
import { pdf } from '@react-pdf/renderer';
import { StatisticsPDF } from './statisticsPDF';
import { formatDate, FormatType } from './utils/utils';
import { Chart } from './statistics';

const generatePdfDocument = async (values: Chart[], base64Charts: string[]) => {
  const blob = await pdf(
    <StatisticsPDF values={values} base64Charts={base64Charts} />
  ).toBlob();
  saveAs(
    blob,
    'estadisticas-' + formatDate(new Date(), FormatType.DOCUMENT) + '.pdf'
  );
};

export default generatePdfDocument;
